import { FC } from 'react'

import { Icon } from '~/components/Icon'

import theme from '~/theme'

import * as Styled from './styles'
import { IFileInputButtonProps } from './types'

export const FileInputButton: FC<IFileInputButtonProps> = ({
  name,
  children,
  icon,
  onChange,
  disabled = false,
  accept = '',
}) => {
  return (
    <Styled.Label
      htmlFor={name}
      data-testid={`label-${name}`}
      style={{ background: theme.colors.primary }}
      $disabled={disabled}
    >
      {!!icon && <Icon name={icon} size={16} color={theme.colors.white} />}
      {children}
      <input
        disabled={disabled}
        aria-disabled={disabled}
        type="file"
        onChange={onChange}
        data-testid={`file-input-${name}`}
        accept={accept}
      />
    </Styled.Label>
  )
}
